import { useContext, useEffect, useRef } from '@wordpress/element';
import axios from 'axios';
import * as Highcharts from 'highcharts/highmaps';
import Context from '../context/context';

const Map = () => {
    const context = useContext(Context);
    const { mapSeries } = context;
    const container = useRef(null);

    useEffect(() => {
        async function anyNameFunction() {
            const geojson = await axios.get(
                '//assets.pewresearch.org/interactives/socialtrends/2017/intermarriage-map/index.json',
            );

            const states = Highcharts.geojson(geojson.data, 'mapline');
            const msa = Highcharts.geojson(geojson.data, 'map');

            const highchartsArgs = {
                chart: {
                    margin: [0, 0, 70, 0],
                    width: container.current.offsetWidth,
                },
                title: {
                    text: null,
                },
                credits: {
                    enabled: false,
                },
                legend: {
                    title: {
                        text: 'Share intermarried:',
                    },
                    layout: 'horizontal',
                    align: 'center',
                    symbolHeight: 12,
                    symbolWidth: 12,
                    symbolRadius: 0,
                    borderWidth: 0,
                    floating: false,
                    verticalAlign: 'bottom',
                    valueDecimals: 0,
                    labelFormatter() {
                        return this.name;
                    },
                    itemMarginBottom: 5,
                    itemStyle: {
                        color: '#000',
                        fontWeight: 'normal',
                        fontSize: '13px',
                        textTransform: 'uppercase',
                        padding: 10,
                    },
                },
                tooltip: {
                    formatter() {
                        return (
                            `<b>${this.point.name}</b><br>` +
                            `<b>${this.point.value}%</b>` +
                            ` of newlyweds are intermarried`
                        );
                    },
                    borderWidth: 0.5,
                    borderColor: '#000',
                    borderRadius: 0,
                    shadow: false,
                    backgroundColor: 'rgba(255,255,255,0.95)',
                },
                mapNavigation: {
                    enabled: false,
                    buttonOptions: {
                        theme: {
                            fill: 'white',
                            'stroke-width': 1,
                            stroke: 'silver',
                            r: 0,
                            states: {
                                hover: {
                                    fill: '#a4edba',
                                },
                                select: {
                                    stroke: '#039',
                                    fill: '#a4edba',
                                },
                            },
                        },
                        verticalAlign: 'bottom',
                    },
                },
                colorAxis: {
                    dataClasses: [
                        {
                            from: 0,
                            to: 9.9,
                            name: '<10%',
                            color: '#eddcad',
                        },
                        {
                            from: 10,
                            to: 14.9,
                            name: '10% to 14%',
                            color: '#cfc99f',
                        },
                        {
                            from: 15,
                            to: 19.9,
                            name: '15% to 19%',
                            color: '#8a9579',
                        },
                        {
                            from: 20,
                            to: 24.9,
                            name: '20% to 24%',
                            color: '#3f614d',
                        },
                        {
                            from: 25,
                            to: 100,
                            name: '25%+',
                            color: '#003a2c',
                        },
                    ],
                },
                series: [
                    {
                        name: 'States',
                        data: states,
                        color: '#fff',
                        enableMouseTracking: false,
                    },
                    {
                        type: 'map',
                        data: mapSeries,
                        mapData: msa,
                        joinBy: ['GEOID', 'msa'],
                        states: {
                            hover: {
                                color: '#333333',
                                borderColor: 'gray',
                                brightness: 0,
                            },
                        },
                        marker: {
                            symbol: 'square',
                        },
                    },
                ],
            };

            Highcharts.mapChart(container.current, highchartsArgs);
        }

        anyNameFunction();
    }, [mapSeries]);

    return (
        <>
            <div id="map" ref={container} />
        </>
    );
};

export default Map;
